export const KEEP_EMBED_LINK = "KEEP_EMBED_LINK"
